import type { infer as zInfer } from "zod";
import * as z from "zod";
import { shopifyMetafieldToDisplayInPortalSchema } from "./shopify-metafield-to-display-in-portal";

export const setShopifyMetafieldsToDisplayInPortal = {
  name: "setShopifyMetafieldsToDisplayInPortal" as const,
  input: z.object({
    shopifyMetafieldsToDisplayInPortal: z.array(
      shopifyMetafieldToDisplayInPortalSchema,
    ),
  }),
  output: z.null(),
};

export type SetShopifyMetafieldsToDisplayInPortalInput = zInfer<
  typeof setShopifyMetafieldsToDisplayInPortal.input
>;
